import TrainTypeReferencesPage from './train-type-references-page';

export default TrainTypeReferencesPage;